import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  initialized: false,
  menuState: true,
  expiredModal: false,
  networkErrorModal: false,
  networkErrorModalError: null,

  token: {},

  projectId: null,

  config: {
    expirationDate: null,
    decimalSeparator: ",",
    thousandSeparator: " ",
    dateFormat: ""
  }
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    init: (state, action) => {
      state.initialized = true;

      state.projectId = action.payload.projectId;

      if (action.payload.token) {
        state.token = action.payload.token;
      }

      state.config.expirationDate = action.payload.expirationDate;
      state.config.decimalSeparator = action.payload.decimalSeparator;
      state.config.thousandSeparator = action.payload.thousandSeparator;
    },

    toggleLeftMenu: state => {
      state.menuState = !state.menuState;
    },

    toggleExpiredModal: state => {
      state.expiredModal = !state.expiredModal;
    },

    toggleNetworkErrorModal: (state, action) => {
      state.networkErrorModal = !state.networkErrorModal;
      state.networkErrorModalError = action.payload;
    }
  }
});

export const {
  init: rxInit,
  toggleLeftMenu: rxToggleLeftMenu,
  updateToken: rxUpdateToken,
  toggleExpiredModal: rxToggleExpiredModal,
  toggleNetworkErrorModal: rxToggleNetworkErrorModal
} = appSlice.actions;

export const appConfigSelector = state => state.app.config;

export default appSlice.reducer;
